//作业列表
export const SK_HOMEWORK_LIST = 'sk_homework_list'
//作业完成学生人数
export const SK_HOMEWORK_STU_COUNT = 'sk_homework_stu_count'
//作业未完成学生人数
export const SK_HOMEWORK_STU_LIST = 'sk_homework_stu_list'
//作业详情
export const SK_HOMEWORK_DETAILS = 'sk_homework_details'
//作业试题列表
export const SK_HOMEWORK_TEST_LIST = 'sk_homework_test_list'
//作业学生完成情况
export const SK_HOMEWORK_STU_MESSAGE = 'sk_homework_stu_message'
//作业编辑
export const SK_HOMEWORK_EDIT = 'sk_homework_edit'
